/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LocalizationSettingsDto
 */
export interface LocalizationSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof LocalizationSettingsDto
     */
    preferredLanguage?: string;
    /**
     * 
     * @type {string}
     * @memberof LocalizationSettingsDto
     */
    dateFormat?: string;
    /**
     * 
     * @type {string}
     * @memberof LocalizationSettingsDto
     */
    timeFormat?: string;
    /**
     * 
     * @type {string}
     * @memberof LocalizationSettingsDto
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof LocalizationSettingsDto
     */
    numberFormat?: string;
    /**
     * 
     * @type {string}
     * @memberof LocalizationSettingsDto
     */
    currencyDisplay?: string;
}

/**
 * Check if a given object implements the LocalizationSettingsDto interface.
 */
export function instanceOfLocalizationSettingsDto(value: object): value is LocalizationSettingsDto {
    return true;
}

export function LocalizationSettingsDtoFromJSON(json: any): LocalizationSettingsDto {
    return LocalizationSettingsDtoFromJSONTyped(json, false);
}

export function LocalizationSettingsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocalizationSettingsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'preferredLanguage': json['preferred_language'] == null ? undefined : json['preferred_language'],
        'dateFormat': json['date_format'] == null ? undefined : json['date_format'],
        'timeFormat': json['time_format'] == null ? undefined : json['time_format'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'numberFormat': json['number_format'] == null ? undefined : json['number_format'],
        'currencyDisplay': json['currency_display'] == null ? undefined : json['currency_display'],
    };
}

export function LocalizationSettingsDtoToJSON(json: any): LocalizationSettingsDto {
    return LocalizationSettingsDtoToJSONTyped(json, false);
}

export function LocalizationSettingsDtoToJSONTyped(value?: LocalizationSettingsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'preferred_language': value['preferredLanguage'],
        'date_format': value['dateFormat'],
        'time_format': value['timeFormat'],
        'currency': value['currency'],
        'number_format': value['numberFormat'],
        'currency_display': value['currencyDisplay'],
    };
}

